import { Skeleton } from '@digdir/designsystemet-react';

export const TiltakLoader = () => <Skeleton height={200} />;
